import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/utilization";

export const PeriodType = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.utilization.periodTypeOptions);
  const selectedFilters = useSelector((state) => state.utilization.selectedPeriodType);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      placeholder="Select Period Type"
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};
